export default function Footer() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="font-heading text-xl font-bold text-primary-400 mb-4">羞羞动漫网站</h3>
            <p className="text-foreground-400 text-sm leading-relaxed">
              动漫美女爆羞羞动漫在线蜜桃等国产精品动漫内容聚合平台。
              汇集51动漫国产精品入口、精品动漫推荐与动漫美女角色资源，
              致力于为动漫爱好者提供最优质的动漫在线体验。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '关于我们', href: '#about' },
                { label: '读者评论', href: '#comments' },
                { label: '精彩视频', href: '#media' },
                { label: '联系我们', href: '#contact' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleScrollTo(e, item.href)}
                  className="text-foreground-500 hover:text-primary-400 text-sm whitespace-nowrap cursor-pointer transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          {/* Content Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">内容板块</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '热门话题', href: '#topics' },
                { label: '最新动态', href: '#updates' },
                { label: '焦点专题', href: '#carousel' },
                { label: '精品推荐', href: '#cards' },
                { label: '专题合集', href: '#index' },
                { label: '热度榜单', href: '#ranking' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleScrollTo(e, item.href)}
                  className="text-foreground-500 hover:text-primary-400 text-sm whitespace-nowrap cursor-pointer transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          {/* Partners */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">合作伙伴</h4>
            <p className="text-foreground-500 text-sm leading-relaxed">
              虚位以待，诚邀优质动漫内容平台、创作者和品牌方合作。
              共同打造更丰富的动漫内容生态。
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="mt-10 pt-8 border-t border-foreground-800/40">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-600 text-xs">
              &copy; {new Date().getFullYear()} 羞羞动漫网站 - 动漫美女爆羞羞动漫在线蜜桃 | 51动漫国产精品入口与精品动漫推荐
            </p>
            <p className="text-foreground-600 text-xs">
              本站内容仅供动漫爱好者交流学习使用
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}